// src/components/PrivacyPolicy.jsx
import React from "react";
import { Container } from "react-bootstrap";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="privacy-section">
      <Container>
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="update-text">This policy was updated on 27th Sep'24.</p>

        <h2 className="section-heading">Scope of Application</h2>
        <p className="privacy-text">
          This Privacy Notice applies to the processing of personal data that is
          collected, which means information about an identifiable individual
          (“you”), that Strat Edge Private Limited, its affiliates and
          subsidiaries (“Company”, “Strat Edge”, “we” or “us”) collect through
          our website (“Tool” or “website”) about you as a visitor of the
          website, applicants, or freelancers (collectively “Applicants”). It
          also describes your data protection rights, including your right to
          object to some of the processing that Strat Edge may carry out. More
          information about your rights and how to exercise them, is set out in
          the Your Choices and Rights section below.
        </p>

        <p className="privacy-text">
          For current or former employees, applicants, contractors,
          subcontractors, and employees of contractors or subcontractors
          (collectively referred to as "workers"), dependents, and
          beneficiaries, the applicable privacy notice is the Worker Privacy
          Notice.
        </p>

        <p className="privacy-link">
          To view the Worker Privacy Notice,{" "}
          <a href="#" className="click-link">
            Click Here
          </a>
        </p>
      </Container>
    </section>
  );
};

export default PrivacyPolicy;
